import { rem } from 'polished';
import styled from 'styled-components';

import { ITextBodyProps } from './TextBody.types';

export const StyledTextBody = styled.p<ITextBodyProps>`
  display: block;
  margin: 0;
  line-height: 140%;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('16px')};
  font-weight: ${({ tag }) => {
    if (tag === 'strong') {
      return 700;
    } else {
      return 400;
    }
  }};
`;
